import React from "react";
import "./Values.css";

const Values = () => {
  return (
    <div className="values">
      <div className="values-container">
        <div className="values-mainText">Our Values</div>
        <div className="values-flex">
          <div className="left-values">
            <div className="value topVal">
              <div className="value-icon">
                <img src="/assets/teamwork.svg" alt="" />
              </div>
              <div className="value-text">
                <div className="value-mainText">Teamwork</div>
                <div className="value-subText">
                  We are everyday people made super-humans by the efforts of our
                  teammates. Together, we draw strength to be the best at what
                  we do.
                </div>
              </div>
            </div>
            <div className="value botVal">
              <div className="value-icon">
                <img src="/assets/security.svg" alt="" />
              </div>
              <div className="value-text">
                <div className="value-mainText">Security</div>
                <div className="value-subText">
                  We understand the need for businesses to feel protected. So we
                  work tirelessly to create a relaxed environment to do
                  business. We find a way to make you win – all the time
                </div>
              </div>
            </div>
          </div>
          <div className="right-values">
            <div className="value topVal">
              <div className="value-icon">
                <img src="/assets/passion.svg" alt="" />
              </div>
              <div className="value-text">
                <div className="value-mainText">Passion</div>
                <div className="value-subText">
                  Our desire to be the driving force of change doesn’t stop at
                  the present solutions we are building. We are committed and
                  ready to push ourselves to the top{" "}
                </div>
              </div>
            </div>
            <div className="value botVal">
              <div className="value-icon">
                <img src="/assets/inclusivity.svg" alt="" />
              </div>
              <div className="value-text">
                <div className="value-mainText">Accessibility</div>
                <div className="value-subText">
                  Qevolt was built with all types of businesses in mind. It does
                  not matter the resources or size of your business, we’re
                  addicted to creating simple and effective solutions to your
                  business problems.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Values;
